/**
 * Misc storefront helpers:
 * - Opens the Reamaze chat widget when the URL contains ?open=chat
 * - Adds a title to the Shopify theme preview bar iframe
 * - Marks decorative third-party SVG icons as aria-hidden
 */
(function () {
  // Open chat from ?open=chat URL parameter
  function openChatFromUrl() {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('open') !== 'chat') return;

    var checkChat = setInterval(function () {
      var chatWidget = document.querySelector('#reamaze-widget');
      if (chatWidget) {
        clearInterval(checkChat);
        setTimeout(function () {
          chatWidget.click();
        }, 500);
      }
    }, 200);
    setTimeout(function () {
      clearInterval(checkChat);
    }, 10000);
  }

  // Give the Shopify preview bar iframe an accessible title
  function setPreviewBarTitle() {
    function apply(frame) {
      if (!frame.title) {
        frame.title = 'Shopify theme preview bar';
      }
    }

    var frame = document.getElementById('PBarNextFrame');
    if (frame) {
      apply(frame);
      return;
    }

    var observer = new MutationObserver(function () {
      var previewFrame = document.getElementById('PBarNextFrame');
      if (previewFrame) {
        apply(previewFrame);
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Hide decorative third-party SVG icons from assistive tech
  function fixDecorativeSvgAccessibility(root) {
    (root || document)
      .querySelectorAll(
        '.gf-refine-toggle-mobile button svg, .gf-refine-toggle-mobile svg, .oke-reviewsSummary-icon > svg'
      )
      .forEach(function (icon) {
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
        icon.setAttribute('role', 'presentation');
      });

    (root || document).querySelectorAll('.oke-reviewsSummary-icon').forEach(function (wrapper) {
      wrapper.setAttribute('aria-hidden', 'true');
    });
  }

  openChatFromUrl();
  setPreviewBarTitle();
  fixDecorativeSvgAccessibility();

  document.addEventListener('DOMContentLoaded', function () {
    fixDecorativeSvgAccessibility();
  });
  window.addEventListener('load', function () {
    fixDecorativeSvgAccessibility();
  });

  var svgObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        fixDecorativeSvgAccessibility(node);
      });
    });
  });
  svgObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
